// Traduções pt-BR do programa de afiliados/indicações do GetPaid. Paridade
// total com affiliate.en.ts (a fonte da verdade) — toda chave existe nos
// dois arquivos.
const affiliate: Record<string, string> = {
  'affiliate.title': 'Afiliados',
  'affiliate.subtitle':
    'Compartilhe seu link de indicação. Quando uma organização indicada por você se cadastra e começa a receber pagamentos, você ganha uma parte da taxa que o GetPaid cobra dela.',

  'affiliate.loading': 'Carregando resumo de afiliados…',
  'affiliate.error': 'Não foi possível carregar o resumo de afiliados.',

  'affiliate.referralLink.label': 'Seu link de indicação',
  'affiliate.referralLink.copy': 'Copiar',
  'affiliate.referralLink.copied': 'Copiado!',
  'affiliate.referralLink.copiedToast': 'Link de indicação copiado para a área de transferência.',
  'affiliate.referralLink.copyFailedToast': 'Não foi possível copiar o link. Copie manualmente.',

  'affiliate.shareNudge':
    'Quem se cadastra com o seu link ganha 50% de desconto na nossa tarifa no primeiro mês — e você ganha uma parte da nossa tarifa pelos primeiros 12 meses dessa organização.',

  'affiliate.stat.currentShare': 'Percentual atual',
  'affiliate.stat.mtdVolume': 'Volume indicado no mês',
  'affiliate.stat.nextTier': 'Próximo nível',
  'affiliate.stat.nextTier.value': 'A partir de {volume} → {share}',
  'affiliate.stat.nextTier.topTier': 'Você está no nível máximo',
  'affiliate.stat.settledEarnings': 'Ganhos liquidados',
  'affiliate.stat.pendingEarnings': 'Ganhos pendentes',

  'affiliate.payoutNotReady.title': 'Adicione seu Pix para receber os ganhos de afiliado',
  'affiliate.payoutNotReady.description':
    'Você já tem ganhos de afiliado, mas precisamos de um destino Pix antes de podermos pagá-los.',
  'affiliate.payoutNotReady.cta':
    'Adicione seu Pix no onboarding para receber os ganhos de afiliado',

  'affiliate.referrals.title': 'Indicações',
  'affiliate.referrals.empty':
    'Nenhuma indicação ainda. Compartilhe seu link para começar a ganhar.',
  'affiliate.referrals.column.name': 'Organização',
  'affiliate.referrals.column.createdAt': 'Indicado em',
  'affiliate.referrals.column.status': 'Status',
  'affiliate.referrals.column.commission': 'Comissão',
  'affiliate.referrals.status.pending': 'Pendente',
  'affiliate.referrals.status.active': 'Ativo',
  'affiliate.referrals.status.churned': 'Cancelado',
  'affiliate.referrals.commission.earningUntil': 'Ganhando até {date}',
  'affiliate.referrals.commission.ended': 'Período de comissão encerrado',
};

export default affiliate;
